import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'WB3-U11-P79-E1',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page79/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Circle and. Then write two sentences for each sentence.', color: "#5B5A5D" }],
    question: {
      Write: {
        inputStyle: { width: 420 },
        answers: ['This is a donkey. These are goats.', 'I like bananas. He likes apples.', 'There is a slide. There are trees.'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { border: 'solid 3px', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: { borderColor: '#4285F4' },
        // limitSelect: 1,
        listWords: [
          'This is a donkey and these are goats. ', //0 
          'I like bananas and he likes apples.',
          'There is a slide and there are trees. ',

        ],
        answers: ['0-8', '1-6', '2-8'],
        initialValue: [],
      },
      Layout: `
      <div style=" display: flex; flex-direction: row; line-height: 58px; justify-content: space-between;width: 1000px;">
        <div>
          <div><b>1 &ensp;</b> Harry is seven  <span style=" border: 3px solid gray; border-radius: 50%; padding: 5px;">and</span> Katie is nine.  </div>
          <div><b>2 &ensp;</b> <input id='0' type='Circle' /></div>
          <div><b>3 &ensp;</b> <input id='1' type='Circle' /></div>
          <div><b>4 &ensp;</b> <input id='2' type='Circle' /></div>
        </div>
        <div>
          <div><u style="color:gray;"> Harry is seven. Katie is nine &ensp;</u></div>
          <div><input id='0' /></div>
          <div><input id='1' /></div>
          <div><input id='2' /></div>
        </div>
      </div>
      `,
    },
  },
  2: {
    unit: 'Unit 11',
    id: 'WB3-U11-P79-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 8,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page79/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page79/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page79/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page79/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/5.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/7.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/9.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page79/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/11.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page79/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/13.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/15.jpg', input: 7, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/17.jpg', input: 8, },
        { url: 'img/FriendsPlus/Page79/E2/18.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page79/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/20.jpg', input: 9, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/22.jpg', input: 10, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/24.jpg', input: 11, },
        { url: 'img/FriendsPlus/Page79/E2/25.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/26.jpg', input: 12, },
        { url: 'img/FriendsPlus/Page79/E2/27.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/28.jpg', input: 13, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/29.jpg' },
        { url: 'img/FriendsPlus/Page79/E2/30.jpg', input: 14, isCorrect: true },
        { url: 'img/FriendsPlus/Page79/E2/31.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page79/E2/32.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page79/E2/37.jpg' },
      ],

    ]
  },

  3: {
    unit: 'Unit 9',
    id: 'WB3-U9-P61-E2',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    hideBtnFooter: true,
    exerciseKey: 'img/FriendsPlus/Page61/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page79/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page79/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page79/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page79/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page79/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page79/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page79/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page79/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/19.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/20.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page79/E3/21.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/22.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/23.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page79/E3/24.jpg' },
        { url: 'img/FriendsPlus/Page79/E3/25.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page79/E3/26.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page79/E3/27.jpg' },
      ],


    ]
  },




}
export default json;